export const RECEIPT_UPLOAD_HIGHLIGHTED_ELEMENT = "receipt-upload__highlight";
